var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_3752_12922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66732 1.33334C5.03551 1.33334 5.33398 1.63182 5.33398 2.00001V2.66668H9.33398V2.00001C9.33398 1.63182 9.63246 1.33334 10.0006 1.33334C10.3688 1.33334 10.6673 1.63182 10.6673 2.00001V2.66668H11.334C11.8644 2.66668 12.3731 2.87739 12.7482 3.25246C13.1233 3.62754 13.334 4.13624 13.334 4.66668V7.33334C13.334 7.70153 13.0355 8.00001 12.6673 8.00001H2.66732V12.6667C2.66732 12.8435 2.73756 13.0131 2.86258 13.1381C2.9876 13.2631 3.15717 13.3333 3.33398 13.3333H7.86398C8.23217 13.3333 8.53065 13.6318 8.53065 14C8.53065 14.3682 8.23217 14.6667 7.86398 14.6667H3.33398C2.80355 14.6667 2.29484 14.456 1.91977 14.0809C1.5447 13.7058 1.33398 13.1971 1.33398 12.6667V4.66668C1.33398 4.13624 1.5447 3.62754 1.91977 3.25246C2.29484 2.87739 2.80355 2.66668 3.33398 2.66668H4.00065V2.00001C4.00065 1.63182 4.29913 1.33334 4.66732 1.33334ZM4.00065 4.00001H3.33398C3.15717 4.00001 2.9876 4.07025 2.86258 4.19527C2.73756 4.3203 2.66732 4.48987 2.66732 4.66668V6.66668H12.0006V4.66668C12.0006 4.48987 11.9304 4.3203 11.8054 4.19527C11.6804 4.07025 11.5108 4.00001 11.334 4.00001H10.6673V4.66668C10.6673 5.03487 10.3688 5.33334 10.0006 5.33334C9.63246 5.33334 9.33398 5.03487 9.33398 4.66668V4.00001H5.33398V4.66668C5.33398 5.03487 5.03551 5.33334 4.66732 5.33334C4.29913 5.33334 4.00065 5.03487 4.00065 4.66668V4.00001ZM11.334 10.1138C10.5572 10.3884 10.0006 11.1292 10.0006 12C10.0006 13.1046 10.8961 14 12.0006 14C12.8715 14 13.6123 13.4435 13.8868 12.6667H12.0006C11.6325 12.6667 11.334 12.3682 11.334 12V10.1138ZM12.6673 10.1138V11.3333H13.8868C13.686 10.7651 13.2356 10.3147 12.6673 10.1138ZM8.66732 12C8.66732 10.1591 10.1597 8.66668 12.0006 8.66668C13.8416 8.66668 15.334 10.1591 15.334 12C15.334 13.841 13.8416 15.3333 12.0006 15.3333C10.1597 15.3333 8.66732 13.841 8.66732 12Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3752_12922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8a34c087bd36ca6e38427f4901483853.svg";
export { ForwardRef as ReactComponent };